import * as indexTypes from './../types/index'
import config from './../../config'

export default {
  state: {
    carousel: [],
    products: []
  },
  getters: {
    [indexTypes.GET_INDEX_CAROUSEL]: state => state.carousel,
    [indexTypes.GET_HOT_PRODUCTS]: state => state.products
  },
  actions: {},
  mutations: {
    [indexTypes.SET_INDEX_CAROUSEL] (state, data) {
      state.carousel = data.map(item => ({
        id: item,
        src: config.imageSrcPrefix + item,
        alt: 'banner'
      }))
    },
    [indexTypes.SET_HOT_PRODUCTS] (state, data) {
      state.products = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/index.js